import { h } from "preact";
import MyFlowTemplatesTable from "./MyFlowTemplatesTable";

export default function MyFlowTemplatesTab({ onSelectTemplate }) {
    return (
        <MyFlowTemplatesTable onCreateFlow={onSelectTemplate} />
    );
}